import './Intro.css'
import bg from '../../assets/Potraitimage.png'
import dbg from '../../assets/darkPotrait.png'
import {Link} from 'react-scroll'
import cv from '../../assets/Resumecv.png'
import Proin from '../ProIn/Proin'
import React,{useEffect} from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';
import resume from '../../assets/resume.pdf' 
import { useTheme } from '../ThemeContext'
import Float from '../Float/Float'
import { ScrollParallax } from 'react-just-parallax'   

const Intro = () => {

const {theme} = useTheme();

  useEffect(() => {
    AOS.init({
      once:true,
      mirror:false
    });
  }, [])

  // let url =``
  return (
    <section id="intro" className={theme==='dark'?'dark-theme':'light-theme'}>
        <div className="introContent" data-aos='fade-right'>
            <span className="hello">👋 Hello! I am </span><br />
            <span className="introName">Yathish Shettigar</span><br />
            <span className="introWork">Front End Developer | UX Designer</span><br />
            <Proin/>
            <button className=' introBtn'><a href='https://drive.google.com/file/d/1McfHe_d9fIUSIV4e682qro7euAD3Wp7c/view?usp=drivesdk' download='resume.pdf' target='_blank' className='introLink' >
            <img src='https://ik.imagekit.io/35sznjvlf/assets/Resumecv.png?updatedAt=1719465281269' alt="cv icon"  />Download CV</a></button>
        </div>
        <div className="bg">
            {theme==='dark'?<img src='https://ik.imagekit.io/35sznjvlf/assets/darkPotrait.png?updatedAt=1719465260925' alt="Person Image" className='bg' data-aos='fade-left' loading='eager'  />:<img src='https://ik.imagekit.io/35sznjvlf/assets/Potraitimage.png?updatedAt=1719465281367' alt="Person Image" className='bg' data-aos='fade-left' loading='eager' />}
        </div>
        <ScrollParallax  isAbsolutelyPositioned >
          <Float className='flow'/>
        </ScrollParallax>
    </section>
  )
}

export default Intro
